/** @jsxImportSource @emotion/react */
import { Snackbar } from '@quickbit/qb-design-system';
import { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { MerchantList, MerchantDetails } from './components';
import { CorporateWallet } from './components/CorporateWallet';

type Alert = {
  type: 'success' | 'danger';
  show: boolean;
  message: string;
};

export const Merchants = () => {
  const [alert, setAlert] = useState<Alert>({
    type: 'success',
    show: false,
    message: '',
  });

  return (
    <>
      <Routes>
        <Route path="/" element={<MerchantList />} />
        <Route
          path="/:merchantId"
          element={
            <MerchantDetails
              onSuccess={(message: string) => {
                setAlert({ show: true, type: 'success', message });
              }}
              onError={(message: string) =>
                setAlert({ show: true, type: 'danger', message })
              }
            />
          }
        />
        <Route
          path="/:merchantId/corporate-wallet"
          element={<CorporateWallet />}
        />
      </Routes>
      <Snackbar
        variant={alert.type}
        message={alert.message}
        onClose={() => setAlert({ ...alert, show: false })}
        open={alert.show}
        hideDuration={null}
      />
    </>
  );
};
